// import Main from './Main'
import Templates from './components/Templates'

export default [
  {path: 'templates', component: Templates, name: 'configuracoes.templates'}
]
